import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const index = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/reading_times', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const fetchAll = () => {
  return api.http.get(`/reading_times/select_search`)
}

export const fetch = id => {
  return api.http.get(`/reading_times/${id}`)
}

export const search = term => {
  return api.http.get('/reading_times/select_search', {
    params: {
      term
    }
  })
}

export const select = (term, callback) => {
  search(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const remove = id => {
  return api.http.delete(`/reading_times/${id}`)
}

export const restore = id => {
  return api.http.put(`/reading_times/${id}/restore`)
}

export const update = params => {
  return api.http.put(`/reading_times/${params._id}`, params)
}

export const create = params => {
  return api.http.post('/reading_times', params)
}

export const ranges = () => {
  return api.http.get('/reading_times/range')
}



// WEBPACK FOOTER //
// ./src/api/readingTimes.js